<section class="feature-medicine-section mt-4" style="background-color: #f2f2f2 0% 0% no-repeat padding-box">
  <div class="container">
    <div class="row container justify-content-center">
      <div>
        <div class="section-heading mt-5">
          <span class="subt-title-left span-30px">RELACIONAMENTO</span>
          <h2 class="title-left" style="line-height: 1.1">CONTÍNUO</h2>
        </div>

        <p class="mt-1">
          Com a Géia você terá todo o suporte necessário, não apenas para a escolha do melhor plano ou seguro, como
          também uma equipe de relacionamento capacitada, sempre pronta para atendimento no pós-venda e no seu dia a dia
          conosco.
        </p>
      </div>
      <div class="col-lg-6 col-md-6 d-none d-sm-none d-md-none d-lg-block order-lg-last">
        <div class="tile-gallery-three">
          <div
            class="image-one"
            style="margin-top: 65px !important; margin-left: -53px !important; width: 69% !important">
            <img src="../../../../assets/app-assets/images/ilustracao/iris-geia-polo.png" alt="Image" />
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-10">
        <div class="feature-content pr-xl-5 mt-md-50">
          <div class="section-heading text-center heading-white container">
            <h2 class="title-left text-rigth mb-1" style="font-size: 24px !important">FALE CONOSCO!</h2>
          </div>
          <form [formGroup]="formGroupEmailContact" (ngSubmit)="onSubmit()" class="form row">
            <div class="form-group col-md-12 mb-2">
              <fieldset class="form-group position-relative has-icon-left">
                <input
                  required
                  name="nome"
                  type="text"
                  id="name"
                  maxlength="50"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid': formGroupEmailContact.controls['name'].errors && formSubmitted
                  }"
                  placeholder="Informe seu nome"
                  class="form-control border-radius ng-dirty ng-valid ng-touched" />
                <div class="form-control-position mr-t-icon">
                  <i class="fa fa-user"></i>
                </div>
                <div
                  *ngIf="formGroupEmailContact.controls['name'].errors?.['required'] && formSubmitted"
                  class="invalid-feedback">
                  Campo obrigatório
                </div>
              </fieldset>
            </div>

            <div class="form-group col-md-6 mb-2">
              <fieldset class="form-group position-relative has-icon-left">
                <input
                  name="celular"
                  type="tel"
                  id="celular"
                  mask="(00) 00000-0000"
                  [showMaskTyped]="true"
                  formControlName="phone"
                  placeholder="Informe o Celular"
                  [ngClass]="{'is-invalid': formGroupEmailContact.controls['phone'].errors && formSubmitted}"
                  class="form-control border-radius ng-dirty ng-valid ng-touched" />
                <div class="form-control-position mr-t-icon">
                  <i class="fa fa-phone"></i>
                </div>
              </fieldset>
            </div>
            <div class="form-group col-md-6 mb-2">
              <fieldset class="form-group position-relative has-icon-left">
                <input
                  name="email"
                  type="text"
                  id="user-email"
                  maxlength="60"
                  formControlName="email"
                  [ngClass]="{'is-invalid': formGroupEmailContact.controls['email'].errors && formSubmitted}"
                  placeholder="Informe o E-mail"
                  class="form-control border-radius ng-dirty ng-valid ng-touched" />
                <div class="form-control-position mr-t-icon">
                  <i class="fa fa-envelope-o"></i>
                </div>
                <div
                  *ngIf="formGroupEmailContact.controls['email'].errors?.['required'] && formSubmitted"
                  class="invalid-feedback">
                  Campo obrigatório
                </div>
                <div
                  *ngIf="formGroupEmailContact.controls['email'].errors?.['pattern'] && formSubmitted"
                  class="invalid-feedback">
                  E-mail Inválido
                </div>
              </fieldset>
            </div>
            <div class="form-group col-md-12 mb-2">
              <textarea
                rows="7"
                class="form-control border-radius"
                name="message"
                formControlName="message"
                placeholder="Insira o texto aqui..."
                [ngClass]="{
                  'is-invalid': formGroupEmailContact.controls['message'].errors && formSubmitted
                }"></textarea>
              <div
                *ngIf="formGroupEmailContact.controls['message'].errors?.['required'] && formSubmitted"
                class="invalid-feedback">
                Campo obrigatório
              </div>
            </div>

            <div class="form-group col-12 mb-2">
              <div class="form-group col-12 mb-2">
                <app-captcha #captcha (tokenChange)="captchaToken = $event"></app-captcha>
              </div>
              <button
                [disabled]="!isSendEmail || !captchaToken"
                class="btn btn-round btn-geia-info bold-azul bold-azul-geia btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1 btn-block">
                ENVIAR
                <i
                  class="bold-azul-geia mr-1"
                  [ngClass]="isLoading ? 'fa fa fa-refresh fa-spin fa-fw' : 'fa fa-arrow-right'"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
